import React from "react"
import { useCardsContext } from "./context/CardsContext"
import TextField from "@mui/material/TextField"
import { Select } from "./Select"
import { ToggleRow, Section } from "./ui"

// Exclusion ("NOT") filters. Expanding the section opens the panel;
// collapsing it clears every exclusion.
export const ExclusionFilters = () => {
  const cardsCtx = useCardsContext()

  return (
    <Section
      title="Exclusions"
      open={!!cardsCtx.openAnti}
      onToggle={() =>
        cardsCtx.setOpenAnti((b) => {
          const nextState = !b
          const willClose = nextState === false
          if (willClose) {
            cardsCtx.handleClearExclusions()
          }
          return nextState
        })
      }
    >
      <p className="section-note">
        These filters work as a NOT operator: matching cards are removed from
        the results.
      </p>
      <TextField
        style={{ marginTop: 6 }}
        label="anti search"
        id="deck-cards-anti-search"
        helperText={
          <>
            Exclude card name or effect text. <br /> Note: ignores any text
            within parenthesis
          </>
        }
        onChange={(e) => cardsCtx.setAnti_Search(e.target.value)}
        value={cardsCtx.anti_search}
        size="small"
      />
      <Select
        label="exclude elements"
        id="select-card-anti-element"
        options={cardsCtx.elementOpts ?? []}
        value={cardsCtx.anti_elements ?? []}
        onChange={cardsCtx.setAnti_Elements}
      />
      <Select
        label="exclude classes"
        id="select-card-anti-class"
        options={cardsCtx.classOpts ?? []}
        value={cardsCtx.anti_classes ?? []}
        onChange={cardsCtx.setAnti_Classes}
      />
      <Select
        label="exclude types"
        id="select-card-anti-type"
        options={cardsCtx.typeOpts ?? []}
        value={cardsCtx.anti_types ?? []}
        onChange={cardsCtx.setAnti_Types}
      />
      <Select
        label="exclude subtypes"
        id="select-card-anti-subtype"
        options={cardsCtx.subtypeOpts ?? []}
        value={cardsCtx.anti_subtypes ?? []}
        onChange={cardsCtx.setAnti_Subtypes}
      />
      <ToggleRow
        label="Exclude Class Bonus"
        checked={cardsCtx.anti_bonus}
        onChange={() => cardsCtx.setAnti_Bonus((b) => !b)}
      />
    </Section>
  )
}
